// src/Components/useSessionKeepAlive.js
import { useEffect, useRef, useState } from "react";
import api from "../utils/api";

function parseJwt(token) {
  try { return JSON.parse(atob(token.split(".")[1])); } catch { return null; }
}

export default function useSessionKeepAlive({
  warnBeforeMs = 15_000,
  autoRefreshIfActive = true,
  onShowModal,
  onHideModal,
} = {}) {
  const timerRef = useRef(null);
  const [expMs, setExpMs] = useState(null);

  const schedule = () => {
    clearTimeout(timerRef.current);

    const access = localStorage.getItem("accessToken");
    const payload = access ? parseJwt(access) : null;
    const exp = payload?.exp ? payload.exp * 1000 : null;

    console.log("[keepAlive] schedule called", {
      hasAccess: !!access,
      payload,
      expReadable: exp ? new Date(exp).toISOString() : null
    });

    setExpMs(exp);
    if (!exp) return;

    const now = Date.now();
    const msLeft = exp - now;
    const fireIn = Math.max(0, msLeft - warnBeforeMs);

    console.log("[keepAlive] msLeft:", msLeft, "warnBefore:", warnBeforeMs, "=> fireIn:", fireIn);

    timerRef.current = setTimeout(async () => {
      const stillLeft = exp - Date.now();
      console.log("[keepAlive] timer fired. stillLeft:", stillLeft, "visible?", document.visibilityState);

      if (stillLeft <= warnBeforeMs) {
        if (autoRefreshIfActive && document.visibilityState === "visible") {
          try {
            console.log("[keepAlive] auto refresh try…");
            await api.post("/refresh", null, { withCredentials: true });
            console.log("[keepAlive] auto refresh ok. reschedule.");
            schedule();
            onHideModal?.();
            return;
          } catch (e) {
            console.warn("[keepAlive] auto refresh failed -> show modal", e);
          }
        }
        console.log("[keepAlive] show modal");
        onShowModal?.();
      } else {
        console.log("[keepAlive] still time left; reschedule");
        schedule();
      }
    }, fireIn);
  };

  useEffect(() => {
    console.log("[keepAlive] mount");
    schedule();
    return () => {
      console.log("[keepAlive] unmount: clear timer");
      clearTimeout(timerRef.current);
    };
    // eslint-disable-next-line
  }, []);

  // 토큰 갱신 시 다시 스케줄
  useEffect(() => {
    const h = () => {
      console.log("[keepAlive] access-token-updated event");
      schedule();
    };
    window.addEventListener("access-token-updated", h);
    return () => window.removeEventListener("access-token-updated", h);
  }, []);

  return { expMs };
}
